/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// INTERFACES
import { MessageTypeInterface } from "../../interfaces/MessageType.interface";
// CONSTANTS
import { BLANK_MESSAGE_TYPE } from "../../constants/messagesTypes";

export interface MessageTypeState {
	messageType: MessageTypeInterface;
	openDrawer: boolean;
	openForm: boolean;
	showTable: boolean;
	refreshTable: boolean;
	formAction: "edit" | "create";
	openModalDelete: boolean;
}

const initialState: MessageTypeState = {
	messageType: { ...BLANK_MESSAGE_TYPE },
	openDrawer: false,
	openForm: false,
	showTable: false,
	refreshTable: false,
	formAction: "create",
	openModalDelete: false,
};

export const messageTypeSlice = createSlice({
	name: "messageType",
	initialState,
	reducers: {
		updateMessageType: (state, action: PayloadAction<MessageTypeInterface>) => {
			state.messageType = action.payload;
		},
		updateOpenDrawer: (state, action: PayloadAction<boolean>) => {
			state.openDrawer = action.payload;
		},
		updateOpenForm: (state, action: PayloadAction<boolean>) => {
			state.openForm = action.payload;
		},
		updateShowTable: (state, action: PayloadAction<boolean>) => {
			state.showTable = action.payload;
		},
		updateRefreshTable: (state, action: PayloadAction<boolean>) => {
			state.refreshTable = action.payload;
		},
		updateFormAction: (state, action: PayloadAction<"edit" | "create">) => {
			state.formAction = action.payload;
		},
		updateOpenModalDelete: (state, action: PayloadAction<boolean>) => {
			state.openModalDelete = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	updateMessageType,
	updateOpenDrawer,
	updateOpenForm,
	updateShowTable,
	updateRefreshTable,
	updateFormAction,
	updateOpenModalDelete,
} = messageTypeSlice.actions;

export default messageTypeSlice.reducer;
